import React, { useRef, useEffect } from "react";
import classes from "./MatchSummary.module.css";

function MacthSummary() {
  let canvasSize = 300;
  let canvas1 = useRef();
  let canvas2 = useRef();
  let canvas3 = useRef();

  const canvasRefs = [canvas1, canvas2, canvas3];

  const createBackgroundDonut = (ctx) => {
    ctx.beginPath();
    ctx.lineWidth = 20;
    ctx.strokeStyle = "#999999";
    ctx.arc(canvasSize / 2, canvasSize / 2, canvasSize / 4 + 5, 0, 2 * Math.PI);
    ctx.shadowBlur = 30;
    ctx.shadowColor = "#222222";
    ctx.shadowOffsetX = "-10";
    ctx.shadowOffsetY = "10";
    ctx.stroke();
  };

  const createForegoundDonut = (ctx, i) => {
    ctx.globalCompositeOperation = "source-over";
    ctx.beginPath();
    ctx.lineWidth = 10;
    ctx.strokeStyle = colors[i];
    ctx.arc(
      canvasSize / 2,
      canvasSize / 2,
      canvasSize / 4 + i * 10,
      1.5 * Math.PI,
      (percents[i] / 100) * 1.5 * Math.PI
    );
    ctx.stroke();
    ctx.textBaseline = "middle";
    ctx.textAlign = "center";
    ctx.font = "30px Arial";
    ctx.fillStyle = colors[i];
    ctx.fillText(
      `${percents[i]}%`,
      canvasSize / 2,
      canvasSize / 2 + (i === 0 ? 15 : -15)
    );
  };

  let colors = ["white", "#aaaaaa"];
  let percents = [50, 90];

  useEffect(() => {
    for (let i = 0; i < 3; i++) {
      let ctx = canvasRefs[i].current.getContext("2d");
      createBackgroundDonut(ctx);
      createForegoundDonut(ctx, 0);
      createForegoundDonut(ctx, 1);
    }
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.main}>
        <div className={classes.top}>
          <div className={classes.topLeft}>
            <div className={classes.topLeftPlayers}>
              <span className={classes.player1Span}>KONRAD WOJTASIK</span>
              <span className={classes.player2Span}>FRANCISZEK JOB</span>
            </div>
          </div>
        </div>
        <div className={classes.mid}>
          <div className={classes.midTop}>
            <span className={classes.setSpan}>SET 1</span>
          </div>
          <div className={classes.midBottom}>
            {[0, 1, 2].map((num) => {
              return (
                <div className={classes.midCol}>
                  <span className={classes.serveSpan}>1st SERVE IN</span>
                  <canvas
                    width={canvasSize}
                    height={canvasSize}
                    ref={canvasRefs[num]}
                  ></canvas>
                </div>
              );
            })}
          </div>
        </div>
        <div className={classes.footer}></div>
      </div>
    </div>
  );
}

export default MacthSummary;
